<div class="gl-dashboard__title">
  <span>{{ 'dashboard.widgets.plan' | translate }}</span>
  <button
    type="button"
    lmsTooltip
    [tooltipConfig]="{
      positionV: 'bottom',
      positionH: 'left',
      text: [
        (mySeatPlan['totalSeats'] ? 'dashboard.widgets.tooltipSeats' : 'dashboard.widgets.tooltipCredits') | translate
      ]
    }"
    class="un-btn"
  >
    <span class="glicon-info"></span>
  </button>
</div>
<div class="gl-dashboard__numWithText">
  <span
    [ngClass]="{
      void:
        (mySeatPlan['totalSeats'] || myCreditPlan['totalCredits']) === 0 ||
        (!(mySeatPlan['totalSeats'] || myCreditPlan['totalCredits']) &&
          (mySeatPlan['totalSeats'] || myCreditPlan['totalCredits']) !== 0)
    }"
    >{{ mySeatPlan['totalSeats'] || myCreditPlan['totalCredits'] || 0 }}</span
  >
  <span class="text">{{ 'dashboard.widgets.' + planType | translate }}</span>
</div>
<div
  class="gl-dashboard__label"
  [innerHTML]="
    mySeatPlan['endDate']
      ? mySeatPlan['totalSeats']
        ? ('dashboard.widgets.validMyPlanSeats'
          | translate : '{ date:\'' + (mySeatPlan['endDate'] | lmsDate : timezone : 'dd/MM/yyyy') + '\'}')
        : ('dashboard.widgets.validMyPlanCredits'
          | translate : '{ date:\'' + (myCreditPlan['endDate'] | lmsDate : timezone : 'dd/MM/yyyy') + '\'}')
      : '&nbsp;'
  "
></div>
<lms-chart-speedometer
  [showHorizontalDouble]="true"
  [primaryValue]="
    mySeatPlan['occupiedSeats'] || myCreditPlan['consumedCredits']
      | lmsCalcPercentage : mySeatPlan['totalSeats'] || myCreditPlan['totalCredits']
  "
  [secondaryValue]="
    mySeatPlan['reservedSeats'] || myCreditPlan['reservedCredits']
      | lmsCalcPercentage : mySeatPlan['totalSeats'] || myCreditPlan['totalCredits']
  "
></lms-chart-speedometer>
<ul class="gl-dashboard-legend">
  <li>
    <span class="gl-dashboard-legend__bullet b-green"></span>
    <div>
      {{ ((mySeatPlan | json) !== '{}' ? 'dashboard.widgets.seatsBusy' : 'dashboard.widgets.creditsBusy') | translate }}
      <b>{{ mySeatPlan['occupiedSeats'] || myCreditPlan['consumedCredits'] || '-' }}</b>
      ({{ getPercentage(mySeatPlan['occupiedSeats'] || myCreditPlan['consumedCredits'] || 0) }}%)
    </div>
  </li>
  <li class="gap">
    <span class="gl-dashboard-legend__bullet b-lightgreen"></span>
    <div>
      {{
        ((mySeatPlan | json) !== '{}' ? 'dashboard.widgets.seatsReserved' : 'dashboard.widgets.assignedCredits')
          | translate
      }}
      <b>{{ mySeatPlan['reservedSeats'] || myCreditPlan['reservedCredits'] || '-' }}</b>
      ({{ getPercentage(mySeatPlan['reservedSeats'] || myCreditPlan['reservedCredits'] || 0) }}%)
    </div>
  </li>
  <li>
    <span class="gl-dashboard-legend__bullet b-grey"></span>
    <div>
      {{ 'dashboard.widgets.seatsAvailable' | translate }}
      <b>{{ mySeatPlan['availableSeats'] || myCreditPlan['availableCredits'] || '-' }}</b>
      ({{ getPercentage(mySeatPlan['availableSeats'] || myCreditPlan['availableCredits'] || 0) }}%)
    </div>
  </li>
</ul>
